import { useEffect } from "react";
import { PageContent, useGetAllParams } from "../hospital-diseases/comp";
import { sendBaikePV } from "../../utils/mping";
import { useLocation } from "react-router-dom";

const departmentCodeMap: any = {
  xinli: {
    code: "7300088",
    name: "精神心理科",
  },
  pifu: {
    code: "7300035",
    name: "皮肤性病科",
  },
};

export default () => {
  // const paramsInfo = useGetAllParams(["departmentCode"]);
  const paramsInfo = useGetAllParams(["departmentCode"]);

  const {
    selectedProvince,
    cityId,
    diseaseId,
    provinceId,
    hospitalId,
    departmentId,
    secondDepartId,
    departmentCode: _departmentCode,
  } = paramsInfo;

  const location = useLocation();

  const departmentCode =
    _departmentCode ||
    location.pathname.split("/")[location.pathname.split("/").length - 1];

  console.log(111, "departmentCode", departmentCode);

  let isXinLi = false;
  let isPiFu = false;

  if (!departmentId && !secondDepartId) {
    if (departmentCode === "xinli") {
      isXinLi = true;
    } else if (departmentCode === "pifu") {
      isPiFu = true;
    }
    const aimDepInfo = departmentCodeMap[departmentCode] || {};
    paramsInfo.secondDepartId = aimDepInfo?.code;
    paramsInfo.secondDepartName = aimDepInfo?.name;
  }

  useEffect(() => {
    switch (departmentCode) {
      case "xinli":
        // 心理专科
        sendBaikePV("InternetHospital_Spiritualpsychology");
        break;
      case "pifu":
        // 心理专科
        sendBaikePV("InternetHospital_Dermatology");
        break;
      default:
    }
  }, []);

  return <PageContent paramsInfo={paramsInfo} />;
};
